<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter paso="2" total-pasos="2" />
      <wrap-container class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.usuarioClave.titulo"
            />
            <div class="subtitulo">
              <p
                class="titulo oscuro"
                v-safe-html="config.pasos.usuarioClave.subtitulo"
              />
            </div>
          </wrap-container>
          <wrap-container>
            <user-name-input
              v-model="model.usuario"
              label="Nombre de usuario"
              name="nombre de usuario"
              :required="true"
              analyticsTypology="validacion de celular usuario y clave"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container>
            <digital-key
              v-model="model.claveDigital"
              label="Clave digital"
              name="clave digital"
              :required="true"
              analyticsTypology="validacion de celular usuario y clave"
              quantumObfuscate
            />
          </wrap-container>
          <step-navigator
            v-model="model"
            store-action="DO_USUARIO_CLAVE"
            :routerPush="false"
          />
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import UserNameInput from "@/components/core/UserNameInput";
import DigitalKey from "@/components/core/DigitalKey";
import FormValidator from "@/components/core/FormValidator";
import StepCounter from "@/components/core/StepCounter";

import StepNavigator from "@/components/core/StepNavigator";

export default {
  name: "UsuarioClave",
  components: {
    WrapContainer,
    FormValidator,
    StepCounter,
    UserNameInput,
    DigitalKey,
    StepNavigator
  },
  data() {
    return {
      model: this.$store.getters.getUsuarioClave()
    };
  },
  methods: {
    onContinue() {
      this.$store.dispatch("DO_USUARIO_CLAVE", this.model);
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
  }
}
</style>
